export default "__VITE_ASSET__DfkkxoJQ__"